// TODO: REWORK ACTIONS

import { findIndex, cloneDeep } from "lodash";
const initialState = {}

export function AbsorbanceTableReducer(state, action) {

  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
    return state;
  }

  switch (action.type) {
    case 'ABSORBANCE_TABLE_CELL_UPDATE':
      return onCellUpdate(state, action.payload);

    case 'UNDO':
        //Payload = {lastState}
        if (action.payload.lastState !== null  && protocolSection.scene.hasOwnProperty('absorbanceTable')) {

          protocolSection.scene.absorbanceTable = action.payload.lastState.scene.absorbanceTable

          return { ...state, ...{
            protocolSection: protocolSection
          } }

        } else {
          return state;
        }

    default:
      return state;
  }
}

function onUpdateCellData(data, payload) {
  const [rowId, colId] = payload.id.split('_').map((id) => parseInt(id));

  return data.map((row, rowIndex) => {
    if (rowIndex === rowId) {
      return row.map((col, colIndex) => {
        if (colIndex === colId) {
          col = {...col, value: payload.value, showFeedback: false};
        }
        return col;
      });
    }
    return row;
  });
}

function onCellUpdate(state, payload) {
  let protocolSection = cloneDeep(state.protocolSection);
  let question = protocolSection.scene.absorbanceTable;

  question.data = onUpdateCellData(question.data, payload);

  protocolSection.scene.absorbanceTable = question;

  return { ...state, ...{
    protocolSection: protocolSection
  } }

}
